import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal/Modal';
import { useForm, Controller } from 'react-hook-form';
import { Button, Input } from 'antd';

import Api from '../Api';
import { errorNotification, successNotification } from '../Snackbar';
import GetField from '../Components/GetField';

const AntInputTextArea = GetField(Input.TextArea);

const RejectModal = props => {
  const { recordId, modalType, hideModal } = props;

  const [confirmLoading, setConfirmLoading] = useState(false);

  const { control, handleSubmit, reset } = useForm();

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post(
        `/fabric-inventory/transfer/${recordId}/reject`,
        formValues
      );
      reset();
      successNotification('Transfer rejected');
      hideModal();
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <Modal
      visible={modalType === 'Reject'}
      onCancel={hideModal}
      centered
      title="Reject"
      width="40%"
      maskClosable={false}
      footer={false}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="respondedRemark"
          control={control}
          render={({ field }) => (
            <AntInputTextArea
              allowClear
              label="Remark"
              placeholder="Remark"
              {...field}
            />
          )}
        />
        <Button type="primary" loading={confirmLoading} htmlType="submit">
          Submit
        </Button>
      </form>
    </Modal>
  );
};

RejectModal.propTypes = {
  recordId: PropTypes.number,
  modalType: PropTypes.string,
  hideModal: PropTypes.func,
};

export default RejectModal;
